import React from 'react';
import { useForm } from "react-hook-form";

const ContactForm = () => {
  const { register, handleSubmit } = useForm();
  const onSubmit = data => console.log(data);
  return (
    <div className="my-5">
      <h1 className="text-center text-warning text-uppercase mb-3">Send Message</h1>
      <div className="row">
        <div className="col-md-3"></div>
        <div className="col-md-6">
          <form onSubmit={handleSubmit(onSubmit)}>
            <input {...register("username", { required: true })}
              className="form-control bg-dark border-secondary py-2"
              placeholder="Full Name"
            />
            <input {...register("email", { required: true })}
              className="form-control my-3 bg-dark border-secondary py-2"
              placeholder="Your Email"
            />
            <textarea cols="80" rows="5"{...register("message", { required: true })} className="form-control my-3 bg-dark border-secondary"
              placeholder="Your Message"
            />
            <input type="submit" value="Send" className="btn btn-outline-light py-2 w-100" />
          </form>
        </div>
        <div className="col-md-3"></div>
      </div>
    </div>
  );
};

export default ContactForm;
